<template>
	<div
		@click="onClick"
		class="display-flex flex-row flex-1 tab-button flex-align-center"
		:class="{
			disabled: isTabDisabled,
			'left-button': tabIndex === 0,
			'right-button': tabIndex === 1,
			'only-button': panels.length === 1,
			active: openedPanelIndex === tabIndex,
		}"
	>
		<div class="display-flex flex-column width-100">
			<div class="tab-title">{{ `${tabIndex + 1}. ${panel.title}` }}</div>
			<div class="tab-description display-flex flex-row flex-align-center">
				{{ panel.description }}
				<AppTooltip position="bottom" :text="panel.tooltipDescription">
					<SIcon class="info-icon ml-1" name="installation-tab-info" width="12" height="12" />
				</AppTooltip>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name: 'InstallationWizardTab',
	props: {
		panels: { type: Array },
		tabIndex: { type: Number },
		openedPanelIndex: { type: Number },
		notValidConfigurationsIds: { type: Array },
	},
	computed: {
		isTabDisabled() {
			if (this.tabIndex === 0) {
				return false;
			} else {
				return this.isPanelNotValid(this.panels[0]);
			}
		},
		panel() {
			return this.panels[this.tabIndex];
		},
	},
	methods: {
		isPanelNotValid(panel) {
			return this.notValidConfigurationsIds.includes(Number(panel.configurationId));
		},
		onClick() {
			if (this.isTabDisabled) {
				return;
			} else {
				this.$emit('tab-clicked', this.tabIndex);
			}
		},
	},
};
</script>
<style scoped lang="scss">
.tab-button {
	height: 50px;
	cursor: pointer;
	&.disabled {
		cursor: default;
	}
	padding: 0px 10px;
	background: var(--bg-color);
	border-left: 1px solid #d2d7e2;
	border-top: 1px solid #d2d7e2;
	border-bottom: 1px solid #d2d7e2;

	font-size: 14px;
	letter-spacing: 0px;
	color: var(--secondary-font-color);

	&.active::after {
		background: #ebf1fd;
	}

	&.active {
		cursor: pointer;
		background: #ebf1fd;
		border-color: #d2d7e2;
		box-shadow: 0px 3px 6px #00000029;
		.tab-title {
			font-weight: bold;
			color: var(--primary-font-color);
		}
	}
}
.left-button {
	border-radius: 10px 0px 0px 10px;
	z-index: 2;
	&::after {
		content: '';
		border-top: 1px solid #d2d7e2;
		border-right: 1px solid #d2d7e2;
		height: 38px;
		height: 36px;
		width: 38px;
		position: relative;
		transform: rotate(42deg);
		background: var(--bg-color);
		right: -27px;
	}
}

.right-button {
	border-radius: 0px 10px 10px 0px;
	z-index: 1;
	margin-left: -6px;
	padding: 0px 0 0 50px;
	border-right: 1px solid #d2d7e2;
}

.only-button {
	border-radius: 10px;
	border-right: 1px solid #d2d7e2;

	&::after {
		display: none;
	}
}

.tab-title {
	font-size: 14px;
	letter-spacing: 0px;
	color: var(--secondary-font-color);
}

.tab-description {
	font-size: 12px;
	letter-spacing: 0px;
	color: var(--secondary-font-color);
}
.info-icon {
	&:hover {
		::v-deep path {
			stroke: var(--primary-font-color);
		}
		::v-deep circle {
			stroke: var(--primary-font-color);
		}
	}
}
</style>
